<template>
    <div class="app_env">
        <img src="../assets/app/1.png" alt="">
        <van-button class="copy_btn" round @click="copy('https://huyu.gmmsj.com')">请前往官网huyu.gmmsj.com</van-button>
    </div>
</template>

<script>
    export default {
        name: 'app-env',
        data() {
            return {}
        },
        computed: {},
        created() {},
        mounted() {},
        methods: {
            copy(text) {
                var that = this
                this.$copyText(text).then(() => {
                  that.$toast('网址复制成功');
                });
            }
        },
        watch: {},
    }
</script>

<style lang="less" scoped>
.app_env {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    z-index: 1000;
    img {
        display: block;
        width: 100%;
        max-width: 525px;
        margin: 0 auto;
    }
    .copy_btn {
        z-index: 1001;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 5rem;
        color: var(--theme);
        font-weight: 700;
        background-color: #FFE692;
        width: 28rem;
        height: 5rem;
        border: none;
    }
}
</style>